<template>
  <div class="absolute max-h-[80vh] max-w-[1124px] mx-auto px-4 top-16 right-0 size-full !font-normal"
    v-show="props.isOpen">
    <div
      class="card !w-full !max-w-[1124px] ml-auto bg-white dark:bg-[#8542b41d] !backdrop-blur-2xl !rounded-[32px] border border-[#9857C81A] overflow-hidden">
      <div class="flex max-h-[80vh]">
        <ul class="w-[336px] bg-[#F0E5FF] dark:!bg-[#6B259E33] p-8 space-y-2">
          <li v-for="item in items" :key="item.label">
            <NuxtLink :to="item.link" @mouseenter="selectedRootItem = item" :class="[
              'flex items-center cursor-pointer px-4 py-2 mb-2 overflow-hidden relative rounded-full text-[#9A4EFF] dark:text-[#BD8DFD]',
              item === selectedRootItem
                ? 'bg-white dark:bg-[#FFFFFF0D] font-medium dark:font-semibold text-black dark:text-white'
                : '',
            ]">
              <component :is="item.icon" class="mr-4" />
              <span>{{ item.label }}</span>
            </NuxtLink>
          </li>
        </ul>
        {{ items.item }}

        <!-- {{ selectedRootItem.items[0][0].items[0].content }} -->
        <div
          class="flex-1 bg-white dark:bg-[#8442B41A] dark:text-white/80 size-full px-8 py-6 overflow-y-auto h-full flex flex-col max-h-[80vh] min-h-[80vh]">
          <WrMenuContent v-if="selectedRootItem" :items="selectedRootItem.items[0][0].items[0].content"
            :variant="selectedRootItem.items[0][0].items[0].variant" :link="selectedRootItem.items[0][0].items[0].link"
            class="h-full dark:text-white/80" @close="handleClose" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import WrAI from "~/components/atoms/icons/WrAI.vue";
import WrDesktop from "~/components/atoms/icons/WrDesktop.vue";
import WrFolder from "~/components/atoms/icons/WrFolder.vue";
import WrFrameworks from "~/components/atoms/icons/WrFrameworks.vue";
import WrIndustries from "~/components/atoms/icons/WrIndustries.vue";
import WrMobile from "~/components/atoms/icons/WrMobile.vue";
import WrProducts from "~/components/atoms/icons/WrProducts.vue";
import WrSettings from "~/components/atoms/icons/WrSettings.vue";
import WrMenuContent from "~/components/global/WrMenuContent.vue";
import WrDevelopment from "../atoms/icons/WrDevelopment.vue";

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(["closeMegamenu"]);

const handleClose = () => {
  emit("closeMegamenu");
  selectedRootItem.value = items.value[0];
};

const selectedRootItem = ref(null);

onMounted(() => {
  if (items.value.length) {
    selectedRootItem.value = items.value[0];
  }
});

const items = ref([
  {
    label: "Development Services",
    link: "/services/development-services",
    icon: markRaw(WrDevelopment),
    root: true,
    items: [
      [
        {
          items: [
            {
              content: [
                {
                  items: [
                    {
                      label: "AI Machine Learning Services",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "ai-machine-learning-services",
                      link: "/services/development-services/ai-machine-learning-services",
                    },
                    {
                      label: "API Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "api-development",
                      link: "/services/development-services/api-development",
                    },
                    {
                      label: "Application Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "application-development",
                      link: "/services/development-services/application-development",
                    },
                    {
                      label: "Application Maintenance & Support",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "application-maintenance-support",
                      link: "/services/development-services/application-maintenance-support",
                    },
                    {
                      label: "Automated Testing Service",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "automated-testing-service",
                      link: "/services/development-services/automated-testing-service",
                    },
                    {
                      label: "Automation Testing",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "automation-testing",
                      link: "/services/development-services/automation-testing",
                    },
                    {
                      label: "AWS Cloud & Migration Services",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "aws-cloud-and-migration-services",
                      link: "/services/development-services/aws-cloud-and-migration-services",
                    },
                    {
                      label: "Blockchain Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "blockchain-development",
                      link: "/services/development-services/blockchain-development",
                    },
                    {
                      label: "Business Automation",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "business-automation",
                      link: "/services/development-services/business-automation",
                    },
                    {
                      label: "Chatbot Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "chatbot-development",
                      link: "/services/development-services/chatbot-development",
                    },
                    {
                      label: "CMS Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "cms-development",
                      link: "/services/development-services/cms-development",
                    },
                    {
                      label: "Dedicated Development Team",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "dedicated-development-team",
                      link: "/services/development-services/dedicated-development-team",
                    },
                    {
                      label: "Desktop Software Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "desktop-software-development",
                      link: "/services/development-services/desktop-software-development",
                    },
                    {
                      label: "DevOps Solutions",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "devops-solutions",
                      link: "/services/development-services/devops-solutions",
                    },
                    {
                      label: "Docker Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "docker-development",
                      link: "/services/development-services/docker-development",
                    },
                    {
                      label: "Ecommerce Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "ecommerce-development",
                      link: "/services/development-services/ecommerce-development",
                    },
                    {
                      label: "FinTech Product Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "finTech-product-development",
                      link: "/services/development-services/finTech-product-development",
                    },
                    {
                      label: "FusionCharts Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "fusioncharts-development",
                      link: "/services/development-services/fusioncharts-development",
                    },
                    {
                      label: "IoT Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "iot-development",
                      link: "/services/development-services/iot-development",
                    },
                    {
                      label: "IT Consulting",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "it-consulting",
                      link: "/services/development-services/it-consulting",
                    },
                    {
                      label: "Kubernetes Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "kubernetes-development",
                      link: "/services/development-services/kubernetes-development",
                    },
                    {
                      label: "Mobile App Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "mobile-app-development",
                      link: "/services/development-services/mobile-app-development",
                    },
                    {
                      label: "Multi-Tenant SaaS Product Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "multi-tenant-saas-product-development",
                      link: "/services/development-services/multi-tenant-saas-product-development",
                    },
                    {
                      label: "MVP Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "mvp-development",
                      link: "/services/development-services/mvp-development",
                    },
                    {
                      label: "NFT Token Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "nft-token-development",
                      link: "/services/development-services/nft-token-development",
                    },
                    {
                      label: "POC Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "poc-development",
                      link: "/services/development-services/poc-development",
                    },
                    {
                      label: "Product Engineering",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "product-engineering",
                      link: "/services/development-services/product-engineering",
                    },
                    {
                      label: "SaaS Product Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "saas-product-development",
                      link: "/services/development-services/saas-product-development",
                    },
                    {
                      label: "Services Content",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "services-content",
                      link: "/services/development-services/services-content",
                    },
                    {
                      label: "Software Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "software-development",
                      link: "/services/development-services/software-development",
                    },
                    {
                      label: "Web Portal Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "web-portal-development",
                      link: "/services/development-services/web-portal-development",
                    }
                  ]
                },
              ],
            },
          ],
        },
      ],
    ],
  },
  {
    label: "Technologies/Languages",
    link: "/services/languages",
    icon: markRaw(WrSettings),
    root: true,
    items: [
      [
        {
          items: [
            {
              content: [
                {
                  items: [
                    {
                      label: "PHP",
                      iconPosition: "bg-[position:-73px_0px]",
                      item: "php",
                      link: "/services/languages/php-development-services",
                    },
                    {
                      label: ".NET",
                      iconPosition: "bg-[position:-73px_-48px]",
                      item: ".net",
                      link: "/services/languages/dot-net-development-services",
                    },
                    {
                      label: "Java",
                      iconPosition: "bg-[position:-73px_-96px]",
                      item: "java",
                      link: "/services/languages/java-development-services",
                    },
                    {
                      label: "Java Script",
                      iconPosition: "bg-[position:-73px_-144px]",
                      item: "javascript",
                      link: "/services/languages/javascript-development-services",
                    },
                    {
                      label: "Python",
                      iconPosition: "bg-[position:-73px_-192px]",
                      item: "python",
                      link: "/services/languages/python-development-services",
                    },
                    {
                      label: "Node JS",
                      iconPosition: "bg-[position:-73px_-384px]",
                      item: "node-js",
                      link: "/services/languages/nodejs-development-services",
                    },
                    {
                      label: "Mean Stack",
                      iconPosition: "bg-[position:-73px_-432px]",
                      item: "mean-stack",
                      link: "/services/languages/mean-stack-development-services",
                    },
                    {
                      label: "Ruby",
                      iconPosition: "bg-[position:-73px_-480px]",
                      item: "ruby",
                      link: "/services/languages/ruby-development-services",
                    },
                    {
                      label: "SharePoint",
                      iconPosition: "bg-[position:-73px_-528px]",
                      item: "sharepoint",
                      link: "/services/languages/sharepoint-development-services",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    ],
  },
  {
    label: "Frameworks",
    link: "/services/frameworks",
    icon: markRaw(WrFrameworks),
    root: true,
    items: [
      [
        {
          items: [
            {
              comp: markRaw(WrMenuContent),
              variant: "frameworks",
              link: "/services/frameworks",
              content: [
                {
                  label: "Backend",
                  items: [
                    {
                      label: "Express",
                      iconPosition: "bg-[position:-146px_0px]",
                      item: "express",
                      link: "/services/frameworks/express-development-services",
                    },
                    {
                      label: "Django",
                      iconPosition: "bg-[position:-146px_-48px]",
                      item: "django",
                      link: "/services/frameworks/django-development-services",
                    },
                    {
                      label: "Laravel",
                      iconPosition: "bg-[position:-146px_-144px]",
                      item: "laravel",
                      link: "/services/frameworks/laravel-development-services",
                    },
                    {
                      label: "Spring",
                      iconPosition: "bg-[position:-146px_-192px]",
                      item: "spring",
                      link: "/services/frameworks/spring-development-services",
                    },
                    {
                      label: "AdonisJS",
                      iconPosition: "bg-[position:-146px_-240px]",
                      item: "adonisjs",
                      link: "/services/frameworks/adonisjs-development-services",
                    },
                    {
                      label: "CodeIgnitor",
                      iconPosition: "bg-[position:-146px_-288px]",
                      item: "codeignitor",
                      link: "/services/frameworks/codeignitor-development-services",
                    },
                    {
                      label: "CakePHP",
                      iconPosition: "bg-[position:-146px_-336px]",
                      item: "cakephp",
                      link: "/services/frameworks/cakephp-development-services",
                    },
                    {
                      label: "Sails.JS",
                      iconPosition: "bg-[position:-146px_-384px]",
                      item: "sails-js",
                      link: "/services/frameworks/sails-js-development-services",
                    },
                    {
                      label: "Yii",
                      iconPosition: "bg-[position:-146px_-432px]",
                      item: "yii",
                      link: "/services/frameworks/yii-development-services",
                    },
                    {
                      label: "Meteor",
                      iconPosition: "bg-[position:-146px_-480px]",
                      item: "meteor",
                      link: "/services/frameworks/meteor-development-services",
                    },
                    {
                      label: "Symfony",
                      iconPosition: "bg-[position:-146px_-528px]",
                      item: "symfony",
                      link: "/services/frameworks/symfony-development-services",
                    },
                    {
                      label: "Ruby on Rails",
                      iconPosition: "bg-[position:-146px_-576px]",
                      item: "ruby-on-rails",
                      link: "/services/frameworks/ruby-on-rails-development-services",
                    },
                    {
                      label: "Flask",
                      iconPosition: "bg-[position:-146px_-624px]",
                      item: "flask",
                      link: "/services/frameworks/flask-development-services",
                    },
                    {
                      label: "Pyramid",
                      iconPosition: "bg-[position:-146px_-672px]",
                      item: "pyramid",
                      link: "/services/frameworks/pyramid-development-services",
                    },
                    {
                      label: "Hadoop",
                      iconPosition: "bg-[position:-146px_-720px]",
                      item: "hadoop",
                      link: "/services/frameworks/hadoop-development-services",
                    },
                  ],
                },
                {
                  label: "Frontend",
                  appendClass: "*:w-full shrink",
                  items: [
                    {
                      label: "VueJS",
                      iconPosition: "bg-[position:-219px_0px]",
                      item: "vuejs",
                      link: "/services/frameworks/vuejs-development-services",
                    },
                    {
                      label: "ReactJS",
                      iconPosition: "bg-[position:-219px_-48px]",
                      item: "reactjs",
                      link: "/services/frameworks/reactjs-development-services",
                    },
                    {
                      label: "AngularJS",
                      iconPosition: "bg-[position:-219px_-96px]",
                      item: "angularjs",
                      link: "/services/frameworks/angularjs-development-services",
                    },
                    {
                      label: "Ember",
                      iconPosition: "bg-[position:-219px_-144px]",
                      item: "ember",
                      link: "/services/frameworks/ember-development-services",
                    },
                    {
                      label: "Backbone",
                      iconPosition: "bg-[position:-219px_-192px]",
                      item: "backbone",
                      link: "/services/frameworks/backbone-development-services",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    ],
  },
  {
    label: "CMS",
    link: "/services/cms-development",
    icon: markRaw(WrFolder),
    root: true,
    items: [
      [
        {
          items: [
            {
              comp: markRaw(WrMenuContent),
              variant: "cms",
              link: "/cms",
              content: [
                {
                  appendClass: "*:w-1/3 shrink",
                  items: [
                    {
                      label: "WordPress",
                      iconPosition: "bg-[position:-292px_0px]",
                      item: "wordpress",
                      link: "/services/cms-development/wordpress-development",
                    },
                    {
                      label: "Drupal",
                      iconPosition: "bg-[position:-292px_-49px]",
                      item: "drupal",
                      link: "/services/cms-development/drupal-development",
                    },
                    {
                      label: "Magento",
                      iconPosition: "bg-[position:-292px_-98px]",
                      item: "magento",
                      link: "/services/cms-development/magento-development",
                    },
                    {
                      label: "Joomla",
                      iconPosition: "bg-[position:-292px_-147px]",
                      item: "joomla",
                      link: "/services/cms-development/joomla-development",
                    },
                    {
                      label: "Shopify",
                      iconPosition: "bg-[position:-292px_-196px]",
                      item: "shopify",
                      link: "/services/cms-development/shopify-development",
                    },
                    {
                      label: "Typo3",
                      iconPosition: "bg-[position:-292px_-245px]",
                      item: "typo3",
                      link: "/services/cms-development/typo3-development",
                    },
                    {
                      label: "Bitrix",
                      iconPosition: "bg-[position:-292px_-294px]",
                      item: "bitrix",
                      link: "/services/cms-development/bitrix-development",
                    },
                    {
                      label: "SquareSpace",
                      iconPosition: "bg-[position:-292px_-343px]",
                      item: "squarespace",
                      link: "/services/cms-development/squarespace-development",
                    },
                    {
                      label: "Prestashop",
                      iconPosition: "bg-[position:-292px_-392px]",
                      item: "prestashop",
                      link: "/services/cms-development/prestashop-development",
                    },
                    {
                      label: "Blogger",
                      iconPosition: "bg-[position:-292px_-441px]",
                      item: "blogger",
                      link: "/services/cms-development/blogger-development",
                    },
                    {
                      label: "vBulletin",
                      iconPosition: "bg-[position:-292px_-490px]",
                      item: "vbulletin",
                      link: "/services/cms-development/vbulletin-development",
                    },
                    {
                      label: "Wix",
                      iconPosition: "bg-[position:-292px_-539px]",
                      item: "wix",
                      link: "/services/cms-development/wix-development",
                    },
                    {
                      label: "Moodle",
                      iconPosition: "bg-[position:-292px_-588px]",
                      item: "moodle",
                      link: "/services/cms-development/moodle-development",
                    },
                    {
                      label: "WooCommerce",
                      iconPosition: "bg-[position:-292px_-637px]",
                      item: "woocommerce",
                      link: "/services/cms-development/woocommerce-development",
                    },
                    {
                      label: "Weebly",
                      iconPosition: "bg-[position:-292px_-686px]",
                      item: "weebly",
                      link: "/services/cms-development/weebly-development",
                    },
                    {
                      label: "ExpressionEngine",
                      iconPosition: "bg-[position:-292px_-735px]",
                      item: "expressionengine",
                      link: "/services/cms-development/expressionengine-development",
                    },
                    {
                      label: "Open Cart",
                      iconPosition: "bg-[position:-292px_-784px]",
                      item: "opencart",
                      link: "/services/cms-development/opencart-development",
                    },
                    {
                      label: "NopCommerce",
                      iconPosition: "bg-[position:-292px_-833px]",
                      item: "nopcommerce",
                      link: "/services/cms-development/nopcommerce-development",
                    },
                    {
                      label: "Umbraco",
                      iconPosition: "bg-[position:-292px_-882px]",
                      item: "umbraco",
                      link: "/services/cms-development/umbraco-development",
                    },
                    {
                      label: "Kentico",
                      iconPosition: "bg-[position:-292px_-931px]",
                      item: "kentico",
                      link: "/services/cms-development/kentico-development",
                    },
                    {
                      label: "Sitecore",
                      iconPosition: "bg-[position:-292px_-980px]",
                      item: "sitecore",
                      link: "/services/cms-development/sitecore-development",
                    },
                    {
                      label: "Keystonejs",
                      iconPosition: "bg-[position:-292px_-1029px]",
                      item: "keystonejs",
                      link: "/services/cms-development/keystonejs-development",
                    },
                    {
                      label: "Strapi",
                      iconPosition: "bg-[position:-292px_-1078px]",
                      item: "strapi",
                      link: "/services/cms-development/strapi-development",
                    },
                    {
                      label: "Ghost",
                      iconPosition: "bg-[position:-292px_-1127px]",
                      item: "ghost",
                      link: "/services/cms-development/ghost-development",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    ],
  },
  {
    label: "Mobility/Mobile Apps",
    link: "/services/mobility",
    icon: markRaw(WrMobile),
    root: true,
    items: [
      [
        {
          items: [
            {
              comp: markRaw(WrMenuContent),
              content: [
                {
                  items: [
                    {
                      label: "Android",
                      iconPosition: "bg-[position:-365px_0px]",
                      item: "android",
                      link: "/services/mobility/android-app-development",
                    },
                    {
                      label: "iOS",
                      iconPosition: "bg-[position:-365px_-49px]",
                      item: "ios",
                      link: "/services/mobility/ios-app-development",
                    },
                    {
                      label: "Hybrid Apps",
                      iconPosition: "bg-[position:-365px_-98px]",
                      item: "hybrid-apps",
                      link: "/services/mobility/hybrid-app-development",
                    },
                    {
                      label: "Xamarin",
                      iconPosition: "bg-[position:-365px_-147px]",
                      item: "xamarin",
                      link: "/services/mobility/xamarin-app-development",
                    },
                    {
                      label: "AR",
                      iconPosition: "bg-[position:-365px_-196px]",
                      item: "ar",
                      link: "/services/mobility/ar-app-development",
                    },
                    {
                      label: "VR",
                      iconPosition: "bg-[position:-365px_-245px]",
                      item: "vr",
                      link: "/services/mobility/vr-app-development",
                    },
                    {
                      label: "ReactNative",
                      iconPosition: "bg-[position:-365px_-294px]",
                      item: "reactnative",
                      link: "/services/mobility/reactnative-app-development",
                    },
                    {
                      label: "Flutter",
                      iconPosition: "bg-[position:-365px_-343px]",
                      item: "flutter",
                      link: "/services/mobility/flutter-app-development",
                    },
                    {
                      label: "NativeScript",
                      iconPosition: "bg-[position:-365px_-392px]",
                      item: "nativescript",
                      link: "/services/mobility/nativescript-app-development",
                    },
                    {
                      label: "Unity",
                      iconPosition: "bg-[position:-365px_-441px]",
                      item: "unity",
                      link: "/services/mobility/unity-app-development",
                    },
                    {
                      label: "Apple Watch App Development",
                      iconPosition: "bg-[position:-365px_-490px]",
                      item: "apple-watch",
                      link: "/services/mobility/apple-watch-app-development",
                    },
                    {
                      label: "Tizen Application Development",
                      iconPosition: "bg-[position:-365px_-539px]",
                      item: "tizen",
                      link: "/services/mobility/tizen-app-development",
                    },
                    {
                      label: "iBeacon App Development Company",
                      iconPosition: "bg-[position:-365px_-588px]",
                      item: "ibeacon",
                      link: "/services/mobility/ibeacon-app-development",
                    },
                    {
                      label: "PhoneGap Development Company",
                      iconPosition: "bg-[position:-365px_-637px]",
                      item: "phonegap",
                      link: "/services/mobility/phonegap-app-development",
                    },
                    {
                      label: "Ionic Framework",
                      iconPosition: "bg-[position:-365px_-686px]",
                      item: "ionic",
                      link: "/services/mobility/ionic-app-development",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    ],
  },
  {
    label: "Desktop",
    icon: markRaw(WrDesktop),
    link: "/services/desktop",
    root: true,
    items: [
      [
        {
          items: [
            {
              comp: markRaw(WrMenuContent),
              content: [
                {
                  items: [
                    {
                      label: "Windows Application Development",
                      iconPosition: "bg-[position:-438px_0px]",
                      item: "windows",
                      link: "/services/desktop/windows-software-development",
                    },
                    {
                      label: "MAC Software Development",
                      iconPosition: "bg-[position:-438px_-48px]",
                      item: "mac",
                      link: "/services/desktop/mac-software-development",
                    },
                    {
                      label: "Cocoa Software Framework",
                      iconPosition: "bg-[position:-438px_-96px]",
                      item: "cocoa",
                      link: "/services/desktop/cocoa-software-development",
                    },
                    {
                      label: "Electron Software Development",
                      iconPosition: "bg-[position:-438px_-144px]",
                      item: "electron",
                      link: "/services/desktop/electron-software-development",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    ],
  },
  {
    label: "Artificial Intelligence (AI)",
    icon: markRaw(WrAI),
    link: "/services/ai",
    root: true,
    items: [
      [
        {
          items: [
            {
              comp: markRaw(WrMenuContent),
              content: [
                {
                  items: [
                         {
                      label: "Machine Learning",
                      iconPosition: "bg-[position:-511px_-50px]",
                      item: "machine-learning",
                      link: "/services/ai/machine-learning",
                    },
                    {
                      label: "Deep Learning",
                      iconPosition: "bg-[position:-511px_-100px]",
                      item: "deep-learning",
                      link: "/services/ai/deep-learning",
                    },
                    {
                      label: "Predictive Analysis",
                      iconPosition: "bg-[position:-511px_-150px]",
                      item: "predictive-analysis",
                      link: "/services/ai/predictive-analysis",
                    },
                    {
                      label: "Image Processing",
                      iconPosition: "bg-[position:-511px_-200px]",
                      item: "image-processing",
                      link: "/services/ai/image-processing",
                    },
                    {
                      label: "Natural Language Processing",
                      iconPosition: "bg-[position:-511px_-250px]",
                      item: "nlp",
                      link: "/services/ai/natural-language-processing",
                    },
                    {
                      label: "Virtual Assistants",
                      iconPosition: "bg-[position:-511px_-300px]",
                      item: "virtual-assistants",
                      link: "/services/ai/virtual-assistants",
                    },
                    {
                      label: "Text & Natural Language Processing",
                      iconPosition: "bg-[position:-511px_-350px]",
                      item: "text-nlp",
                      link: "/services/ai/text-natural-language-processing",
                    },
                    {
                      label: "Images, Video & Computer Vision",
                      iconPosition: "bg-[position:-511px_-400px]",
                      item: "vision",
                      link: "/services/ai/images-video-computer-vision",
                    },
                    {
                      label: "Search Relevance",
                      iconPosition: "bg-[position:-511px_-450px]",
                      item: "search-relevance",
                      link: "/services/ai/search-relevance",
                    },
                    {
                      label: "Data Enrichment & Categorization",
                      iconPosition: "bg-[position:-511px_-500px]",
                      item: "data-enrichment",
                      link: "/services/ai/data-enrichment-categorization",
                    },
                    {
                      label: "Audio & Speech-to-Text",
                      iconPosition: "bg-[position:-511px_-550px]",
                      item: "speech-to-text",
                      link: "/services/ai/audio-speech-to-text",
                    },
                    {
                      label: "Assisted Data Labeling",
                      iconPosition: "bg-[position:-511px_-600px]",
                      item: "data-labeling",
                      link: "/services/ai/assisted-data-labeling",
                    },
                    {
                      label: "Assisted Video Object Tracking",
                      iconPosition: "bg-[position:-511px_-650px]",
                      item: "video-tracking",
                      link: "/services/ai/assisted-video-object-tracking",
                    },
                    {
                      label: "Model Creation",
                      iconPosition: "bg-[position:-511px_-750px]",
                      item: "model-creation",
                      link: "/services/ai/model-creation",
                    },
                    {
                      label: "Sentiment Analysis",
                      iconPosition: "bg-[position:-511px_-800px]",
                      item: "sentiment-analysis",
                      link: "/services/ai/sentiment-analysis",
                    },
                    {
                      label: "Text Categorization/classification",
                      iconPosition: "bg-[position:-511px_-850px]",
                      item: "text-categorization",
                      link: "/services/ai/text-categorization-classification",
                    },
                    {
                      label: "Intent Classification",
                      iconPosition: "bg-[position:-511px_-900px]",
                      item: "intent-classification",
                      link: "/services/ai/intent-classification",
                    },
                    {
                      label: "Entity Recognition",
                      iconPosition: "bg-[position:-511px_-950px]",
                      item: "entity-recognition",
                      link: "/services/ai/entity-recognition",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    ],
  },
  {
    label: "Industries",
    icon: markRaw(WrIndustries),
    link: "/services/industries",
    root: true,
    items: [
      [
        {
          items: [
            {
              comp: markRaw(WrMenuContent),
              content: [
                {
                  items: [
                    {
                      label: "Health Care and Fitness",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "ai-agent-development",
                      link: "/services/industries/health-care-and-fitness",
                    },
                    {
                      label: "Education and Training",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "ai-chatbot-development",
                      link: "/services/industries/education-and-training",
                    },
                    {
                      label: "Retail and eCommerce",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "machine-learning",
                      link: "/services/industries/retail-and-ecommerce",
                    },
                    {
                      label: "Sports and Entertainment",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "deep-learning",
                      link: "/services/industries/sports-and-entertainment",
                    },
                    {
                      label: "Media and Publishing",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "predictive-analysis",
                      link: "/services/industries/media-and-publishing",
                    },
                    {
                      label: "Food and Beverage",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "image-processing",
                      link: "/services/industries/food-and-beverage",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    ],
  },
  {
    label: "Maintenance Services",
    link: "/services/maintenance-services",
    icon: markRaw(WrProducts),
    root: true,
    items: [
      [
        {
          items: [
            {
              comp: markRaw(WrMenuContent),
              content: [
                {
                  items: [
                    {
                      label: "Laravel Maintenance Services",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "ai-agent-development",
                      link: "/services/maintenance-services/laravel",
                    },
                    {
                      label: "WordPress Maintenance Services",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "ai-chatbot-development",
                      link: "/services/maintenance-services/wordpress",
                    },
                    {
                      label: "Mobile App Maintenance Services",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "machine-learning",
                      link: "/services/maintenance-services/mobile-apps",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    ],
  },
]);
</script>
